import TreeContainer from "../../../../components/tree/TreeContainer";
import React, {Fragment} from "react";
import {getStrRgba, getStrRgbaAlpha1} from "../../../../utility/common";

export default function AlberoStrutturaKpiView({
                                                   treeData,
                                                   filtroKpi,
                                                   translate,
                                                   onClickItem,
                                               }) {

    return (
        <div className={'ns-overflow-auto ns-overflow-tree'}>
            <TreeContainer
                data={treeData}
                idSelected={filtroKpi.kpiSel && filtroKpi.kpiSel.id}
                onClickItem={onClickItem}
                getLabel={(elemento) => {
                    return (
                        <Fragment>
                            {
                                elemento.colore && elemento.colore !== '' &&
                                <span className="sost-semaforo-kpi me-2" style={{
                                    backgroundColor: getStrRgba(elemento.colore),
                                    border: "solid 1px ",
                                    borderColor: getStrRgbaAlpha1(elemento.colore)
                                }}/>
                            }
                            {elemento.codice + ' - ' + translate(elemento.label)}
                        </Fragment>
                    )
                }}
                getFigli={(elemento) => elemento.nodes}
                icona={(el) => <i className={el.icona_classe}/>}
                initEsploso={false}
                startOpen={(el) => el.tipo == '1'}
            />
        </div>
    );
}